"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Mode = exports.ChainId = void 0;
/**
 * ID of a Celo chain.
 */
var ChainId;
(function (ChainId) {
  ChainId[ChainId["Alfajores"] = 44787] = "Alfajores";
  ChainId[ChainId["Baklava"] = 62320] = "Baklava";
  ChainId[ChainId["Mainnet"] = 42220] = "Mainnet";
})(ChainId = exports.ChainId || (exports.ChainId = {}));
var Mode;
(function (Mode) {
  Mode["Dark"] = "dark";
  Mode["Light"] = "light";
})(Mode = exports.Mode || (exports.Mode = {}));